import { useTheme } from 'styled-components';
import { useTranslation } from 'react-i18next';
import { Badge, useScreenResolution } from 'dash-ui';
import { DATE_FORMAT } from 'dash-common';
import moment from 'moment';

function VerifiedBadge({
  verifiedAt,
  isSmall = false,
}: {
  verifiedAt?: string | null;
  isSmall?: boolean;
}) {
  const { t: tLabels } = useTranslation('common', { keyPrefix: 'labels' });
  const {
    devices: { isTablet },
  } = useScreenResolution();

  const theme = useTheme();

  return (
    <Badge
      title={`${tLabels`developerVerified`} ${
        verifiedAt ? moment(verifiedAt).format(DATE_FORMAT) : ''
      }`}
      bgColor={theme.colors.setOpacity(theme.colors.g20, 70)}
      titleColor={theme.colors.white}
      sm={isTablet || isSmall}
      semibold={false}
      md={!isSmall}
      py={2}
      square={true}
    />
  );
}

export default VerifiedBadge;
